import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { ChiamaAPI, Bottone, Trad, BaseComponent } from '../components/';
import $ from 'jquery';
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';
import ChiamaWeb, { CChiamaWebParametri } from '../ChiamaWeb';

interface IBancaDatiGareProps {
    CIG: string;
    Aggiornare: number;
    UtilizzaBancaDataGare: (dgc: Dati.CBancaDatiGare) => void;
}

interface IBancaDatiGareState {
    Caricamento: boolean;
    Aggiornare: number;
    Parametri: Dati.TListaParametri;
    Dati?: Dati.CRisAPILista<Dati.CBancaDatiGare>;
}

export class BancaDatiGare extends BaseComponent<IBancaDatiGareProps, IBancaDatiGareState> {

    public constructor(props: any) {
        super(props);
        let Param: Dati.CParamAPIPagine = new Dati.CParamAPIPagine();
        Param.Sessione = Glob.GetSessione().Sessione;
        Param.Numero = 10;
        Param.Pagina = 1;
        this.state = { Aggiornare: this.props.Aggiornare, Caricamento: true, Dati: undefined, Parametri: {} };
        this.OnRis = this.OnRis.bind(this);
        this.OnErroreBancaDatiGare = this.OnErroreBancaDatiGare.bind(this);
        //Con il bind si può scrivere: onChange={this.OnChange}
        //altrimenti va utilizzata la sintassi: onChange={(e) => this.OnChange(e)}
        this.OnChange = this.OnChange.bind(this);
    }

    Tabella: any = null;
    TabellaOrdinamento: [number, string] = [1, 'asc'];
    TabellaAggiorna: number = 0;

    private AttivaTabella() {
        if (this.TabellaAggiorna != this.state.Aggiornare + this.props.Aggiornare) {
            this.TabellaAggiorna = this.state.Aggiornare + this.props.Aggiornare;
            if (this.state.Dati != undefined && this.state.Dati.Dati.length > 0) {
                let T: any = $(this.refs.tabella);

                this.Tabella = T.DataTable({
                    responsive: true,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: false,
                    destroy: true
                });
            }
        }
    }

    public componentDidMount() {
        this.AttivaTabella();
    }

    public componentDidUpdate() {
        this.AttivaTabella();
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPILista<Dati.CBancaDatiGare>, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.TabellaAggiorna = 0;
            if (this.Tabella != null) {
                this.Tabella.destroy();
            }
            this.setState({ Dati: dati, Caricamento: false }, () => this.AttivaTabella());
        }
        if (dati.Errore) {
            return false;
        }
        if (dati.Dati.length == 0) {
            return <tbody><tr>
                <td colSpan={11} className="TextLeft alert-warning">
                    <div className="kt-alert__icon">
                        <i className="fa fa-exclamation-triangle"> </i>
                        <span>{Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}</span>
                    </div>
                </td>
            </tr></tbody>;
        }
        else {
            return <tbody>
                {dati.Dati.map(dato =>
                    <tr key={dato.ID_BancaDatiGara}>
                        <td data-field="Utilizza" className="TextLeft"><Bottone OnClick={(e) => { this.UtilizzaBancaDatiGare(dato) }} Testo={Trad.Trad("Utilizza")} /></td>
                        <td data-field="ID_Anag" className="TextCenter">{Glob.GetSessione().ID_Anag == dato.ID_Anag ? "Si" : "No"}</td>
                        <td data-field="ID_Utente" className="TextCenter">{Glob.GetSessione().ID_Utente == dato.ID_Utente ? "Si" : "No"}</td>
                        <td data-field="CIG" className="TextCenter">{dato.CIG}</td>
                        <td data-field="NumeroUtilizzi" className="TextRight">{dato.NumeroUtilizzi}</td>
                        <td data-field="DataGara" className="TextCenter">{Trad.TradParam("{1-D}", [dato.DataGara])}</td>
                        <td data-field="DataPresentazione" className="TextCenter">{Trad.TradParam("{1-D}", [dato.DataPresentazione])}</td>
                        <td data-field="ImportoComplessivo" className="TextRight">{Trad.TradParam("{1-I}", [dato.ImportoComplessivo])}</td>
                        <td data-field="OggettoGaranzia" className="TextLeft"><span title={dato.OggettoGaranzia}>{Glob.TagliaStringa(dato.OggettoGaranzia, 50)}</span></td>
                        <td data-field="LuogoEsecuzione" className="TextLeft">{dato.LuogoEsecuzione}</td>
                        <td data-field="Modificato" className="TextCenter">{Trad.TradParam("{1-D}", [dato.Modificato])}</td>
                    </tr>
                )}
            </tbody>;
        }
    }

    private UtilizzaBancaDatiGare(bdg: Dati.CBancaDatiGare) {
        this.props.UtilizzaBancaDataGare(bdg);
        //const Param: CChiamaWebParametri = {
        //    Metodo: "GET",
        //    URL: "/api/BancaDatiGare/Utilizza?ID_BancaDatiGara=" + bdg.ID_BancaDatiGara,
        //    OnRis: (sender: ChiamaWeb, dati: any) => {
        //        this.setState({ Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
        //    }
        //};
        //new ChiamaWeb().Chiama(Param);
    }

    private OnErroreBancaDatiGare(sender: ChiamaAPI, errore: Error) {
        this.setState({ Caricamento: false });
        return <tbody><tr><td colSpan={11}>{Trad.Trad("ListaErrore")}</td></tr></tbody>;
    }

    public render() {
        return <table className="table table-hover dtr-inline dataTable" id="tabella" ref="tabella">
            <thead>
                <tr className="sfondoTab">
                    <td data-field="Utilizza" className="TextLeft"></td>
                    <td data-field="ID_Anag" className="TextCenter">{Trad.Trad("StessoID_Anag")}</td>
                    <td data-field="ID_Utente" className="TextCenter">{Trad.Trad("StessoID_Utente")}</td>
                    <td data-field="CIG" className="TextCenter">{Trad.Trad("CIG")}</td>
                    <td data-field="NumeroUtilizzi" className="TextRight">{Trad.Trad("NumeroUtilizzi")}</td>
                    <td data-field="DataGara" className="TextCenter" > {Trad.Trad("DataGara")}</td >
                    <td data-field="DataPresentazione" className="TextCenter" > {Trad.Trad("DataPresentazione")}</td >
                    <td data-field="ImportoComplessivo" className="TextRight" > {Trad.Trad("ImportoComplessivo")}</td >
                    <td data-field="OggettoGaranzia" className="TextLeft" > {Trad.Trad("OggettoGaranzia")}</td >
                    <td data-field="LuogoEsecuzione" className="TextLeft" > {Trad.Trad("LuogoEsecuzione")}</td >
                    <td data-field="Modificato" className="TextCenter" > {Trad.Trad("Data")}</td >
                </tr >
            </thead >
            <ChiamaAPI Aggiornare={this.state.Aggiornare + this.props.Aggiornare} URL={"/api/BancaDatiGare/Ricerca?CIG=" + this.props.CIG} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErroreBancaDatiGare} />
        </table >;
    }
}



// WEBPACK FOOTER //
// ./src/components/BancaDatiGare.tsx